export class ConfigDB {
	static data = {
		settings: {
			layout_type:  'ltr',
			sidebar: {
				type: 'compact-wrapper',
			},
			sidebar_setting: '',
		},
		color: {
			primary_color: '#e3380d',
			secondary_color: '#9f9a04',
			mix_background_layout: 'light-only',
		},
		router_animation: 'fadeIn'
	}
}

export default ConfigDB;




